import React, { type CSSProperties, type ReactNode } from 'react'

import { type CustomAccount } from './importDummyDataHelpers'
import { ImportProgressModal } from './ImportProgressModal'
import { type ImportStepDef, useImportForm } from './useImportForm'

const textAreaStyle: CSSProperties = {
  width: '100%',
  height: '200px',
  resize: 'none',
  overflowY: 'auto',
}

interface ImportFormProps {
  title: string
  defaultCustomAccount: CustomAccount
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getInitialData: () => any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validateData: (data: any) => boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSteps: (data: any) => ImportStepDef[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dependencies?: any[]
  extraControls?: ReactNode
}

export const ImportForm = ({
  title,
  defaultCustomAccount,
  getInitialData,
  validateData,
  getSteps,
  dependencies = [],
  extraControls,
}: ImportFormProps) => {
  const { payload, setPayload, handleSubmit, modalProps } = useImportForm({
    title,
    ready: defaultCustomAccount !== null,
    getInitialData,
    validateData,
    getSteps,
    dependencies,
  })

  return (
    <fieldset
      style={{
        minWidth: '400px',
        maxWidth: '600px',
        padding: '20px',
        border: '2px solid black',
        borderRadius: '5px',
        flex: '1',
      }}
    >
      <legend style={{ fontSize: '1.2em', padding: '0 10px' }}>
        Import {title}
      </legend>
      <form onSubmit={event => void handleSubmit(event)}>
        <textarea
          style={textAreaStyle}
          value={payload}
          onChange={e => setPayload(e.target.value)}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: '12px',
            marginTop: '10px',
          }}
        >
          {extraControls}
          <button className='admin-button' type='submit'>
            Submit {title}
          </button>
        </div>
      </form>
      <ImportProgressModal title={title} {...modalProps} />
    </fieldset>
  )
}
